import {
  FILE_UPLOAD_OPTION,
  FILE_NAME,
  FILE_URL,
  FILE_UPLOAD,
  FILE_SELECTED_NAME,
  FILE_SELECTED_URL,
  SELECTED_PERIODS,
  CUSTOM_BOOKING_DATE,
  PERIOD_IS_SELECTED
} from './fields'

export const transformValuesToBE = ({ values }) => {
  const isFileUpload = values[FILE_UPLOAD_OPTION] === FILE_UPLOAD

  const commonFileData = {
    approval_status: 'pending_approval',
    [FILE_NAME]: isFileUpload ? values[FILE_NAME] : values[FILE_SELECTED_NAME],
    [FILE_URL]: isFileUpload ? values[FILE_URL] : values[FILE_SELECTED_URL]
  }

  // user can set which booked_media periods and media files the uploaded file should apply to.
  // by default only one period is selected (the one user clicked on), but user can select multiple periods
  const selectedPeriods = Object.values(values[SELECTED_PERIODS]).filter(period => period[PERIOD_IS_SELECTED])

  return selectedPeriods.map(period => ({
    ...commonFileData,
    // requested file
    media_product_file: period.data.requested_file.id,
    booked_media: period.data.booked_media.id,
    // if there is a custom date, it is important to set it
    ...(period.data.requested_file.custom_date && {
      [CUSTOM_BOOKING_DATE]: period.data.requested_file.date_start
    })
  }))
}
